import styles from './styles.module.scss';

export const typeWarningClasses = {
  default: styles.default,
  purple: styles.purple,
  warning: styles.warning
};

export const defaultTypeWarning = 'default';
